import styled from 'styled-components';
import TextField from '@sdk/components/forms/TextField';

export const Wrapper = styled.div<{ transparentBackground: boolean }>`
  position: relative;
  max-width: 205px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;

  input {
    ${({ transparentBackground }) =>
      transparentBackground ? 'background-color: transparent;' : ''}
  }
`;

type InputProps = {
  hasRightIcon: boolean;
};

export const SearchInput = styled(TextField).withConfig({
  shouldForwardProp: (prop) => !['hasRightIcon'].includes(prop),
})<InputProps>`
  input {
    width: 36px;
    transition:
      all ease-in-out 0.25s,
      background ease 0.3s,
      border-color ease 0.3s;
    border-color: transparent;
    ${(props) => (props.hasRightIcon ? 'padding-right: 30px' : '')};

    &::placeholder {
      opacity: 0.5;
      transition: opacity ease-in-out 0.3s;
    }

    &:not(:focus)::placeholder {
      opacity: 0;
    }

    &:not(:placeholder-shown),
    &:focus {
      width: 205px;
      padding-left: 35px;
    }

    &:not(:placeholder-shown) {
      border-color: ${({ theme }) => theme.colors.separatorOnWhite};

      &:focus {
        border-color: ${({ theme }) => theme.colors.primary};
      }
    }

    &:not(:focus):hover {
      background-color: ${({ theme }) => theme.colors.hoverBrand};
    }
  }
`;

type SearchImageWrapperProps = {
  isActive: boolean;
};

const AbsoluteIconContainer = styled.label`
  align-items: center;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  position: absolute;
  width: 36px;
  height: 36px;
  top: 0;

  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`;

export const SearchImageWrapper = styled(AbsoluteIconContainer)<SearchImageWrapperProps>`
  opacity: ${({ isActive }) => (isActive ? 1 : 0.65)};
  left: 0;
`;

export const CloseImageWrapper = styled(AbsoluteIconContainer)`
  width: 30px;
  right: 0;
  opacity: 0.65;
`;

export const FloatingLabel = styled.div`
  position: absolute;
  bottom: -18px;
  left: 0;
  white-space: nowrap;
`;

export const SearchLabelButton = styled.span`
  background-color: ${(props) => props.theme.colors.iconGray};
  color: ${(props) => props.theme.colors.white};
  border-radius: 2px;
  display: inline-block;
  font-size: 7px;
  font-weight: bold;
  padding: 0 5px;
`;
